import { render, staticRenderFns } from "./FiveCardLayout.vue?vue&type=template&id=e2e9003c&scoped=true"
var script = {}
import style0 from "./FiveCardLayout.vue?vue&type=style&index=0&id=e2e9003c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e9003c",
  null
  
)

export default component.exports